export default __webpack_public_path__ + "static/media/name-selection.c790294b.gif";